import { createContext, useContext } from 'react';
export const TabsContext = createContext({
    fullWidth: false,
    size: 'default',
    variant: 'underline',
    currentValue: undefined,
    updateIndicatorRef: { current: () => { } },
});
export function useTabsContext() {
    return useContext(TabsContext);
}
//# sourceMappingURL=TabsContext.js.map